// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"8493ca17","125":"479bab93","211":"f3bda1dc","288":"6810b284","906":"ce5fa92c","922":"db84785b"}[chunkId] + ".js";
};